<template>
  <div class="notification" v-if="dataList && dataList.length > 0">
    <div class="menu-bar">
      <div class="menu-item menu-item-blue" @click="orderAndeballRead">{{ $t('notification.markAllRead') }}</div>
      <div class="menu-item" @click="expand">
        {{ hideAll ? $t('notification.expand', { count: dataListquantity }) : $t('notification.collapse', {
          count:
            dataListquantity
        }) }}
      </div>
    </div>
    <div class="alert-content">
      <div class="new-order-alert" v-for="(value, index) in dataList" :key="index" v-if="!hideAll">
        <div class="title-content">
          <div class="alert-title">
            <img src="@/assets/svg/horn.svg" alt="" style="width: 30px; height: 30px;" />
            {{ value.title }}
          </div>
          <!-- <div class="order-info" v-if="value.url == '/guest/order/orderDetail/detail'">
            <div>客人姓名：{{ value.name }}</div>
            <div>联系电话：{{ value.phone }}</div>
            <div>订单号：{{ value.orderNo }}</div>
          </div> -->
          <div class="order-info flex-item">
            {{
              value.content.length > 100 ? value.content.substring(0, 100) + '...' : value.content
            }}
          </div>
        </div>

        <div class="action-buttons">
          <div class="ignore-btn" @click="clicksingleRead(value, index)">{{ $t('notification.ignore') }}</div>
          <div @click="clickCheck(value, index)">{{ $t('common.view') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { unReadMessagess, singleRead, allRead, allebAccount } from '@/api/systemSet';

  export default {
    components: {},

    data() {
      return {
        dataList: [],
        backupdataList: [],
        idAlreadyRead: [],
        hideAll: false,
        numberOfRequestMessageInterfaces: 0,
        time: '',
        dataListquantity: 0,
      };
    },

    computed: {
      notificationOccupied() {
        return !this.hideAll && this.dataList && this.dataList.length > 0;
      },
    },

    watch: {
      notificationOccupied: {
        handler(active) {
          this.$store.commit('app/SET_AI_FLOAT_SUPPRESSOR', { name: 'notification', active });
        },
        immediate: true,
      },
      '$store.getters.socketMessage'(msg) {
        const { type, childrenType, context } = msg;
        if (type === 'message' && childrenType === 'order') {
          let item = JSON.parse(context);
          msg.content = item.content;
          msg.url = item.url;
          msg.param = item.param;
          this.dataList.unshift(msg);
          this.dataListquantity = this.dataListquantity + 1;
        }
        if (childrenType === 'ebAccount') {
          let item = JSON.parse(context);
          msg.content = item.content;
          msg.url = item.url;
          msg.param = item.param;
          this.dataList.unshift(msg);
          this.dataListquantity = this.dataListquantity + 1;
        }
      },
    },

    created() { },
    mounted() {
      this.getList();
    },
    beforeDestroy() {
      this.$store.commit('app/SET_AI_FLOAT_SUPPRESSOR', { name: 'notification', active: false });
    },
    methods: {
      expand() {
        this.hideAll = !this.hideAll;
        this.$store.commit('app/SET_MESSAGE_NOTIFICATION_DISPLAY', this.hideAll);
      },
      //获取订单消息
      getList() {
        unReadMessagess({
          hotelCode: this.$store.state.user.hotelCode,
          typeCodeList: ['order', 'ebAccount'],
          pageNum: 1,
          pageSize: 15,
        }).then((res) => {
          if (res.code == 0) {
            this.dataList = res.data || [];
            this.dataListquantity = res.total;
          }
        });
      },
      // 单条已读
      clicksingleRead(value, index) {
        this.idAlreadyRead.push(value.id);
        singleRead({
          id: value.id,
        }).then((res) => {
          if (res.code == 0) {
            if (this.time) clearTimeout(this.time);
            this.time = setTimeout(() => {
              this.getList();
            }, 1500);
          }
        });
        this.dataList = this.dataList.filter((item) => !this.idAlreadyRead.includes(item.id));
      },
      // 查看
      clickCheck(value, index) {
        if (value.childrenType == 'ebAccount' || value.typeCode == 'ebAccount') {
          value.url = '/setting/ebManagement';
        }
        this.clicksingleRead(value, index);
        if (
          value.url == '/guest/roomOrder/roomOrderDetail/detail' ||
          value.url == '/guest/roomOrder/list/1'
        )
          window.open('/guest/roomOrder/roomOrderDetail/detail?orderRoomNo=' + value.param, '_blank');
        else if (value.url == '/guest/order/orderDetail/detail')
          window.open(value.url + '?orderNo=' + value.param, '_blank');
        else this.$router.push(value.url);
      },

      // 全部已读
      orderAndeballRead() {
        this.dataList = [];
        allRead({
          hotelCode: this.$store.state.user.hotelCode,
          typeCodeList: ['order', 'ebAccount'],
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .notification {
    width: 300px;
    height: auto;
    max-height: 90%;
    position: fixed;
    bottom: 43px;
    right: 1.4vw;
    z-index: 9999;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    flex-direction: column-reverse;

    .menu-bar {
      display: flex;
      flex-direction: row-reverse;
      font-weight: 400;
      font-size: 12px;
      color: #1f6aff;

      .menu-item {
        width: 80px;
        height: 32px;
        box-shadow: 0px 12px 16px 0px rgba(40, 54, 65, 0.06);
        border-radius: 4px;
        border: 1px solid #1f6aff;
        color: #1f6aff;
        text-align: center;
        line-height: 32px;
        margin-right: 16px;
        box-sizing: border-box;
        background-color: #fff;
        opacity: 1;
        cursor: pointer;
      }

      .menu-item-blue {
        background-color: #1f6aff;
        color: #fff;
      }
    }

    .alert-content {
      max-height: calc(100vh - 135px);
      display: flex;
      overflow: hidden;
      flex-direction: column-reverse;
      overflow-y: auto;
      scrollbar-width: none;
      /* Firefox 隐藏滚动条 */
      -ms-overflow-style: none;
      /* IE / Edge 隐藏滚动条 */
    }

    .new-order-alert {
      width: 300px;
      background: linear-gradient(180deg, #dbe8ff 0%, #ffffff 40%, #ffffff 100%);
      box-shadow: 0px 12px 16px 0px rgba(40, 54, 65, 0.06);
      border-radius: 4px;
      margin-bottom: 8px;

      .title-content {
        padding: 0 16px;
      }

      .alert-title {
        height: 48px;
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        border-bottom: 1px solid #d6e4ff;
      }

      .order-info {
        padding: 16px 0 4px 0px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        min-height: 90px;
        line-height: 25px;
        padding-bottom: 16px;

        div {
          margin-bottom: 12px;
        }
      }

      .flex-item {
        display: flex;
        align-items: center;
      }

      .action-buttons {
        display: flex;
        border-top: 1px solid #f0f0f0;
        height: 31px;
        line-height: 31px;
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        color: #1f6aff;
        cursor: pointer;

        div {
          flex: 1;
        }

        .ignore-btn {
          border-right: 1px solid #f0f0f0;
        }
      }
    }
  }
</style>
